import { create } from "zustand";
import { locales } from "./localeTranslations";
import { getLocale } from "./localeUtils";
import type {
  localeNames,
  localeTranslations
} from "@dealer-center/core-interfaces-locale";
import { isLocaleName } from "@dealer-center/core-interfaces-locale";

interface LocaleStore {
  locale: localeNames;
  setLocale: (locale: localeNames) => void;
  getLocaleString: (name: localeTranslations) => string;
}

export const useLocaleStore = create<LocaleStore>((set, get) => ({
  locale: getLocale(),
  setLocale: (locale: localeNames) => {
    if (isLocaleName(locale)) {
      set({ locale });
    }
  },
  getLocaleString: (name: localeTranslations) => {
    const { locale } = get();
    const stringMap = locales[locale];
    const returnValue = stringMap[name];
    return returnValue || name;
  }
}));
